import { render } from "./electricalTable.vue?vue&type=template&id=64f91f9d"
import script from "./electricalTable.vue?vue&type=script&lang=js"
export * from "./electricalTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__